/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import axios from 'axios';
import { getUrl } from '../utils/helper';
import { EmojiData } from 'emoji-mart';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Course } from '../types/course/Course';
import { Student } from '../types/Student';
import { ModulePackage } from '../types/course/ModulePackage';

export class CourseService {
	public createCourse(
		token: string,
		emoji: EmojiData,
		courseName: string,
		startDate: MaterialUiPickersDate
	): Promise<void> {
		return axios.post(
			`${getUrl()}/courses`,
			{
				emoji: emoji,
				name: courseName,
				startDate: startDate,
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
	}

	public getCourses(token: string): Promise<Course[]> {
		return axios
			.get<Course[]>(`${getUrl()}/courses`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				return res.data;
			});
	}

	public getCourse(token: string, courseId: string): Promise<Course> {
		return axios
			.get<Course>(`${getUrl()}/courses/${courseId}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				return res.data;
			});
	}

	public getCourseStudents(token: string, courseId: string): Promise<Student[]> {
		return axios
			.get<Student[]>(`${getUrl()}/courses/${courseId}/students`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				return res.data;
			});
	}

	public getCourseModulePackages(token: string, courseId: string): Promise<ModulePackage[]> {
		return axios
			.get<ModulePackage[]>(`${getUrl()}/courses/${courseId}/modulePackages`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				return res.data;
			});
	}

	public addCourseModulePackage(courseId: string, modulePackageId: string, token: string): Promise<void> {
		return axios.post(
			`${getUrl()}/courses/${courseId}/addModulePackage/${modulePackageId}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
	}

	public removeCourseModulePackage(courseId: string, modulePackageId: string, token: string): Promise<void> {
		return axios.post(
			`${getUrl()}/courses/${courseId}/removeModulePackage/${modulePackageId}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
	}
}
